module.exports = __webpack_public_path__ + "img/reservation.5cf0fd88.svg";